import { Tooltip } from 'antd'
import { disable_pencil, pencil_img } from '../../assets/images'
import ToggleButton from '../../components/common/atoms/ToggleButton'
import { SALES_ROLE } from '../../constants/overview'

const manageEmployeeTableSchema = ({data, moveToEditEmployee, openModel, role, openBookAppointmentModal}) =>{
  let toggleStatus = data.customer_status === 'Active' ? true : false
  let status = data.customer_status
  let bgColor ={'Active' : '#C4F1D8', 'Inactive': '#FFE4E4'}
  let textColor = {'Active': '#324467' , 'Inactive' : '324467' }

  return (
    <tr className='text-gray-600' key={data.id}>
      <td className='py-2.5 px-3' style={{width : '20%'}}>
        <span className='leading-4'>{data.employee_id}</span>
      </td>
      <td className={`py-2.5 px-3 ${role === 'sales' && 'filter blur-sm select-none' }`} style={{width : '25%'}}>
      <span className='font-semibold leading-3'>{data.name}</span>
      <div>{data.email}</div>
      </td>
      <td className={`py-2.5 px-3 ${role === 'sales' && 'filter blur-sm select-none' }`} style={{width : '15%'}}>
      <span>{data.mobile_number ?? 'NA'}</span>
      </td>
      <td className={`py-2.5 px-3 ${role === 'sales' && 'filter blur-sm select-none' }`} style={{width : '10%'}}>
      <span>{data.gender}</span>
      </td>
      <td className='py-2.5 px-3' style={{width : '11%'}}>
        <span className='py-1.5 px-2.5 rounded-full font-semibold leading-4' style={{backgroundColor : bgColor[status], color : textColor[status]}}>{status}</span>
      </td>
      <td className='py-2.5 flex flex-row text-center' >   
        <>
        { openBookAppointmentModal && <span  className={`px-2.5 py-1.5 2xl:py-2.5 2xl:px-3 self-center hover:bg-blue-100 rounded-md ${( role === 'sales'|| !toggleStatus || !(data.ahc_enabled && !data.demo_customer)) ? 'cursor-not-allowed' : 'cursor-pointer'}`}> <Tooltip placement='bottomRight' overlayStyle={{maxWidth : '1000px'}} title={(role === 'sales' || !toggleStatus || !(data.ahc_enabled && !data.demo_customer) ) ? 'Booking disabled' : 'Book Appointment' }><button disabled={(role === 'sales' || !toggleStatus || !(data.ahc_enabled && !data.demo_customer))} className={`text-blue-600 text-sm font-medium ${(!toggleStatus) ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={(e) => openBookAppointmentModal(e, data)}>Book</button></Tooltip></span> }
          <span  className={`px-2.5 py-1.5 2xl:py-2.5 2xl:px-3 mx-2 self-center hover:bg-blue-100  rounded-md ${role === 'sales' || !toggleStatus ? 'cursor-not-allowed' : 'cursor-pointer'}`}> <Tooltip placement='bottomRight' overlayStyle={{maxWidth : '1000px'}} title={!toggleStatus ? 'Editing a deactivated employee is not allowed' : 'Edit Employee' }><button disabled={(role === 'sales' || !toggleStatus)} className={`text-blue-600 text-sm font-medium ${(role == 'sales' || !toggleStatus) ? 'cursor-not-allowed' : 'cursor-pointer'}`}  onClick={() =>  ( role !== 'sales' || toggleStatus ) && moveToEditEmployee(data)}>Edit</button></Tooltip></span>
          <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}><Tooltip className='' placement='bottomRight' overlayStyle={{maxWidth : '1000px'}}  title={`${toggleStatus ? 'Deactivate Employee' : 'Reactivate Employee' } `}  > <ToggleButton disabled={role === 'sales'} name = 'status' toggle={toggleStatus}  onChangeHandler={(event) => openModel(event,data.id, data.name)}/></Tooltip></span>
        </>
        
      </td>

    </tr>
  )
}


export default manageEmployeeTableSchema